import React from "react"

import "./QuestionNumber.scss"

import RoundProgress from "@Quiz/Ui/RoundProgress"

const QuestionNumber: React.FC<{ meta: Quiz.Api.Meta, fadeOut: boolean }> = ({ meta, fadeOut }) => {
  return (
    <div className={`neo__quizQuestionNumber ${fadeOut ? "--fadeOut" : "--fadeIn"}`} data-testid="quiz-question-number">
      <RoundProgress
        currentQuestionNumber={meta.question_results.length + 1}
        numTotalQuestions={meta.num_questions} />
    </div>
  )
}

export default QuestionNumber
